import InputNumberTwo from "./InputNumberTwo";

const ParamsInputs = ({ data, setData, disabled, formatData}) => {
    return <div 
        className="std-historical-div"
    >
        {Object.entries(data).map(([key, value]) => {
            const step = formatData[key][0];
            const min = formatData[key][1];
            return <div
                key={key}
                    >
                        {key}
                        <InputNumberTwo 
                            parameter={key}
                            value={value}
                            setValue={setData}
                            disabled={disabled}
                            step={step}
                            min={min}
                        />
            </div>
        })}
    </div>
}

export default ParamsInputs;